import type {ImageField, LinkField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import cn from 'classnames'
import {useLinkResolver} from 'prismicio'
import {ButtonV2} from 'src/common/ButtonV2'
import {DEFAULT_PADDING, PADDING_BOTTOM_CLASS, PADDING_TOP_CLASS} from 'src/common/paddingClasses'
import {TimelineCard} from './TimelineCard'

export type TimelineCardData = {
  title: string
  description: string
  image: ImageField
}

export type TimelineCarouselProps = {
  cards: TimelineCardData[]
  buttonLabel: string
  buttonLink: LinkField
  pageUid: string
  sliceType: string
  variation: string
  paddingTop?: string | null
  paddingBottom?: string | null
}

export const TimelineCarousel = ({
  cards,
  buttonLabel,
  buttonLink,
  pageUid,
  sliceType,
  variation,
  paddingTop,
  paddingBottom,
}: TimelineCarouselProps) => {
  const {linkResolver} = useLinkResolver()

  const buttonHref = buttonLabel && isFilled.link(buttonLink) ? linkResolver(buttonLink, 'timeline') : undefined
  const paddingTopClass = PADDING_TOP_CLASS[paddingTop ?? DEFAULT_PADDING] ?? ''
  const paddingBottomClass = PADDING_BOTTOM_CLASS[paddingBottom ?? DEFAULT_PADDING] ?? ''

  return (
    <section
      className={cn('flex flex-col items-center gap-12 bg-moss-white', paddingTopClass, paddingBottomClass)}
      data-slice-type={sliceType}
      data-slice-variation={variation}
    >
      {cards.length > 0 && (
        <div className="no-scrollbar flex w-full snap-x snap-mandatory scroll-pl-5 gap-10 overflow-x-auto px-5 md:scroll-pl-[max(40px,calc((100vw-1200px)/2))] md:px-[max(40px,calc((100vw-1200px)/2))] lg:scroll-pl-[max(20px,calc((100vw-1200px)/2))] lg:px-[max(20px,calc((100vw-1200px)/2))] xl:scroll-pl-[max(0px,calc((100vw-1200px)/2))] xl:px-[max(0px,calc((100vw-1200px)/2))]">
          {cards.map((card, cardIndex) => (
            <TimelineCard key={cardIndex} title={card.title} description={card.description} image={card.image} />
          ))}
        </div>
      )}
      {buttonHref && (
        <ButtonV2
          href={buttonHref}
          variant="primary"
          trackingData={{
            location: 'timeline',
            dataType: 'primary-button',
            mktgId: '',
            pageName: pageUid,
          }}
        >
          {buttonLabel}
        </ButtonV2>
      )}
    </section>
  )
}
